import ProfileService from "@/services/ProfileService";
import AuthService from '@/services/AuthService';
import { SET_INFO_RELATION } from "../mutation-types";
//default state
const initialState = () => ({
  infoRelation: {}
});
const state = initialState();
const mutations = {
  [SET_INFO_RELATION](state, value) {
    state.infoRelation = value;
  },
};
const actions = {
  async getProfile({ }, key) {
    return await ProfileService.getProfile(key);
  },
  async getMe({commit}) {
    const data = await AuthService.getMe()
    if(data) commit(SET_INFO_RELATION, data)
    return true
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};